// SYLEKSA — luxury reveal-on-scroll & micro-interactions
(function () {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Mark <html> so the CSS can switch reveal targets into the hidden state.
  // Without this class, all .syleksa-reveal elements stay fully visible (safe default).
  document.documentElement.classList.add('js-ready');

  function initReveal() {
    const targets = document.querySelectorAll('.syleksa-reveal');
    if (!targets.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -5% 0px', threshold: 0.01 }
    );

    targets.forEach((el) => io.observe(el));

    // Hard safety: if any element is still hidden after 2s (e.g. observer didn't fire), force visible.
    window.setTimeout(() => {
      document.querySelectorAll('.syleksa-reveal:not(.is-visible)').forEach((el) => {
        el.classList.add('is-visible');
      });
    }, 2000);
  }

  function initParallax() {
    if (prefersReducedMotion) return;
    const layers = document.querySelectorAll('[data-syleksa-parallax]');
    if (!layers.length) return;

    // Smoothed depth: each frame eases toward target with a low coefficient.
    const state = new Map();
    layers.forEach((layer) => {
      state.set(layer, { current: 0, target: 0, speed: parseFloat(layer.dataset.syleksaParallax) || 0.18 });
    });

    let scheduled = false;
    function readTargets() {
      const viewportH = window.innerHeight;
      layers.forEach((layer) => {
        const rect = layer.parentElement.getBoundingClientRect();
        const progress = (rect.top + rect.height / 2 - viewportH / 2) / viewportH;
        const s = state.get(layer);
        // +60% depth — 224 was 140
        s.target = -progress * s.speed * 224;
      });
      scheduled = false;
    }

    function animate() {
      layers.forEach((layer) => {
        const s = state.get(layer);
        // Lerp toward target — slightly faster lerp to track the bigger motion smoothly
        s.current += (s.target - s.current) * 0.11;
        layer.style.transform = `translate3d(0, ${s.current.toFixed(2)}px, 0)`;
      });
      window.requestAnimationFrame(animate);
    }

    window.addEventListener('scroll', () => {
      if (!scheduled) {
        scheduled = true;
        window.requestAnimationFrame(readTargets);
      }
    }, { passive: true });

    readTargets();
    window.requestAnimationFrame(animate);
  }

  /* ---------- Mouse-follow ambient glow inside hero ---------- */
  function initHeroGlow() {
    if (prefersReducedMotion) return;
    const heroes = document.querySelectorAll('.syleksa-hero');
    if (!heroes.length) return;
    // Skip on touch / small screens to keep mobile snappy.
    if (window.matchMedia('(hover: none), (max-width: 749px)').matches) return;

    heroes.forEach((hero) => {
      let rafId = null;
      let nextX = 50;
      let nextY = 50;
      const apply = () => {
        hero.style.setProperty('--syleksa-glow-x', nextX + '%');
        hero.style.setProperty('--syleksa-glow-y', nextY + '%');
        rafId = null;
      };
      hero.addEventListener('pointermove', (e) => {
        const rect = hero.getBoundingClientRect();
        nextX = ((e.clientX - rect.left) / rect.width) * 100;
        nextY = ((e.clientY - rect.top) / rect.height) * 100;
        if (!rafId) rafId = window.requestAnimationFrame(apply);
      });
      hero.addEventListener('pointerleave', () => {
        nextX = 50; nextY = 50;
        if (!rafId) rafId = window.requestAnimationFrame(apply);
      });
    });
  }

  /* ---------- 3D card tilt on ingredient cards ---------- */
  function initCardTilt() {
    if (prefersReducedMotion) return;
    if (window.matchMedia('(hover: none), (max-width: 749px)').matches) return;
    const cards = document.querySelectorAll('.syleksa-ingredient-card');
    if (!cards.length) return;

    const MAX_TILT = 10;

    cards.forEach((card) => {
      let rafId = null;
      let nextTx = 0;
      let nextTy = 0;
      let nextGx = 50;
      let nextGy = 50;
      const apply = () => {
        card.style.setProperty('--tx', nextTx + 'deg');
        card.style.setProperty('--ty', nextTy + 'deg');
        card.style.setProperty('--glow-x', nextGx + '%');
        card.style.setProperty('--glow-y', nextGy + '%');
        rafId = null;
      };
      card.addEventListener('pointermove', (e) => {
        const rect = card.getBoundingClientRect();
        const px = (e.clientX - rect.left) / rect.width;
        const py = (e.clientY - rect.top) / rect.height;
        nextTx = (px - 0.5) * 2 * MAX_TILT;
        nextTy = -(py - 0.5) * 2 * MAX_TILT;
        nextGx = px * 100;
        nextGy = py * 100;
        if (!rafId) rafId = window.requestAnimationFrame(apply);
      });
      card.addEventListener('pointerleave', () => {
        nextTx = 0; nextTy = 0; nextGx = 50; nextGy = 50;
        if (!rafId) rafId = window.requestAnimationFrame(apply);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initReveal();
      initParallax();
      initHeroGlow();
      initCardTilt();
    });
  } else {
    initReveal();
    initParallax();
    initHeroGlow();
    initCardTilt();
  }
})();
